// extracted by mini-css-extract-plugin
module.exports = {"item":"Inspections_item_2oHk9"};